export default {
  common: {
    appName: 'ฮันนี่แบดเจอร์ เอ็นเตอร์เทนเมนต์',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    submit: 'ส่ง',
    save: 'บันทึก',
    usernameRequired: 'กรุณากรอกชื่อผู้ใช้!',
    passwordRequired: 'กรุณากรอกรหัสผ่าน!',
    viewMore: 'ดูเพิ่มเติม',
    refreshSuccess: 'รีเฟรชสำเร็จ',
    noMore: 'ไม่มีข้อมูลเพิ่มเติม',
    emptyData: 'ยังไม่มีข้อมูล',
  },
  footer: { home: 'หน้าแรก', lottery: 'หวย', game: 'จอง', video: 'วิดีโอ', mine: 'ของฉัน' },
  lang: { title: 'ภาษา / Language', current: 'ภาษาปัจจุบัน' },
  home: {
    recommendedTasks: 'ภารกิจแนะนำ',
    popularRanking: 'อันดับความนิยม',
    hotRecommend: 'แนะนำยอดนิยม',
    playCount: 'ดู:{count}',
    noticeLoading: 'กำลังโหลด...',
  },
  game: {
    hallTitle: 'ห้องจอง',
    categoryAll: 'ทั้งหมด',
  },
  choose: {
    title: 'คอมพานิอน',
    tabCities: 'รายการเมือง',
    tabProcess: 'ขั้นตอนและราคา',
    privacyNotice: 'แพลตฟอร์มที่มีสาวบริวาร เพื่อนนักธุรกิจ และนัดพบในท้องถิ่นที่แท้จริงที่สุดบนเน็ต เพื่อปกป้องความเป็นส่วนตัวของผู้ใช้ทุกคน ลูกค้าเข้าร่วมได้ผ่านพนักงานต้อนรับหรือการแนะนำจากสมาชิกอาวุโสเท่านั้น',
    resourcesQ: 'มีตัวเลือกอะไรบ้าง?',
    resourcesA: 'อินฟลูเอนเซอร์ นางแบบ แอร์โฮสเตส นางแบบสาว นักศึกษา — คิดได้เราจัดให้ได้',
    scopeQ: 'ขอบเขตบริการ?',
    scopeA: 'นัดพบในท้องถิ่นฟรี บินหาคุณได้ทุกจุดทั่วประเทศ มีบริการในเมืองใหญ่ทั่วไป และเมืองรองนัดหมายผ่านพนักงานต้อนรับได้',
    book: 'จอง',
    contactConcierge: 'โปรดติดต่อที่ปรึกษาหรือพนักงานต้อนรับ',
    cityNames: {
      beijing: 'ปักกิ่ง',
      shanghai: 'เซี่ยงไฮ',
      guangzhou: 'กว่างโจว',
      shenzhen: 'เชินเจิ้น',
      nanjing: 'หนานจิง',
      changsha: 'ฉางซา',
      chongqing: 'ฉงชิ่ง',
      xian: 'ซีอาน',
    },
  },
  lottery: {
    gameRecord: 'ประวัติภารกิจ',
    orderList: 'ใบสั่งภารกิจ',
    orderItemDetail: '1 เดิมพัน X {money} = {money}',
    clearOrder: 'ล้างใบสั่ง',
    confirmSubmit: 'ยืนยันและส่ง',
    availableBalance: 'ยอดคงเหลือที่ใช้ได้',
    yuan: 'บาท',
    currentPick: 'ตัวเลือกปัจจุบัน: ',
    amountPerBet: 'จำนวนเงินต่อเดิมพัน: ',
    amountPlaceholder: 'กรอกจำนวนเงิน',
    amountInvalid: 'จำนวนเงินไม่ถูกต้อง!',
    fillAmount: 'กรุณากรอกจำนวนเงิน!',
    selectNumberFirst: 'กรุณาเลือกตัวเลข!',
    insufficientBalance: 'ยอดคงเหลือไม่เพียงพอ กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อเติมเงิน!',
    notSelected: 'ยังไม่ได้เลือก',
    contactAdminForTask: 'กรุณาติดต่อผู้ดูแลระบบเพื่อรับภารกิจนี้!',
    drawSuccess: 'ประกาศผลแล้ว รอบ: {expect}',
    periodNumber: 'รอบ',
    betUnit: 'รายการ',
    totalAmountLabel: 'ยอดรวม: ',
    totalCountLabel: 'จำนวนรายการรวม: ',
    drawResult: 'ตัวเลขที่ออก',
    big: 'ใหญ่',
    small: 'เล็ก',
    single: 'คี่',
    doubleNum: 'คู่',
    rules: {
      title: 'วิธีเล่น',
      tipTitle: 'วิธีเล่น',
      tipDetail: 'เลือกตัวเลขจากชุดผลรวมที่เปิดให้เพื่อทำการเดิมพัน',
      winTitle: 'เงื่อนไขการชนะ',
      winDetail: 'ผลรวมของตัวเลขที่ออก 3 ตัว อยู่ระหว่าง 11~18 คือ ใหญ่; ระหว่าง 3~10 คือ เล็ก',
      exampleTitle: 'ตัวอย่างการเดิมพัน',
      exampleDetail: 'เดิมพัน: เล็ก / ตัวเลขที่ออก: 123 → ผล: เล็ก',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: 'เติมเงิน', withdraw: 'ถอนเงิน', game: 'เดิมพัน' },
    },
    withdraw: {
      amountLabel: 'จำนวนเงินถอน (บาท)',
      all: 'ทั้งหมด',
      limitRule1: '1.วงเงินต่อครั้ง: ต่ำสุด {min} สูงสุด {max}',
      limitRule2: '2.จำนวนครั้งที่ถอน: ถอนได้สูงสุด {num} ครั้งต่อวัน',
      limitRule3: '3.ระยะเวลาการโอน: โดยทั่วไปประมาณ 5 นาที เร็วที่สุดภายใน 2 นาที',
      limitTitle: 'รายละเอียดวงเงิน',
      balanceLabel: 'ยอดคงเหลือ: ',
      submit: 'ถอนทันที',
      amountInvalid: 'กรุณากรอกจำนวนเงินให้ถูกต้อง',
    },
    bindCard: {
      formLabel: 'กรุณากรอกข้อมูลบัตรรับเงินของคุณ',
      bankidLabel: 'หมายเลขบัตร',
      bankidPlaceholder: 'กรอกหมายเลขบัตรจริง',
      bankLabel: 'ชื่อธนาคาร',
      bankPlaceholder: 'กรุณาเลือกธนาคาร',
      notice: 'เรียนรักษาคุณ หากต้องการความปลอดภัยของเงิน โปรดใช้ชื่อจริงและตั้งรหัสผ่านการถอน หากชื่อไม่ตรงกับชื่อผู้เปิดบัญชี จะไม่สามารถถอนได้',
      submit: 'ยืนยันการผูกบัตร',
      bankidRequired: 'กรุณากรอกหมายเลขบัตร!',
      bankRequired: 'กรุณาเลือกธนาคาร!',
    },
    setbank: {
      title: 'ข้อมูลบัตรรับเงิน',
      addCard: 'เพิ่มบัตรรับเงิน',
      tips: 'หมายเหตุ: โปรดผูกกับธนาคารพาณิชย์ขนาดใหญ่ หากต้องการแก้ไข โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์',
      setNameFirst: 'กรุณาตั้งชื่อก่อนผูกบัตรธนาคาร!',
      setPayPasswordFirst: 'กรุณาตั้งรหัสผ่านการถอนก่อนผูกบัตรธนาคาร!',
    },
    setPayPassword: {
      firstPrompt: 'กรุณากรอกรหัสผ่านการถอน',
      secondPrompt: 'กรุณากรอกรหัสผ่านการถอนอีกครั้ง',
      incomplete: 'กรุณากรอกให้ครบ',
      mismatch: 'รหัสผ่านสองครั้งไม่ตรงกัน!',
    },
    setLoginPassword: {
      oldPassword: 'รหัสผ่านเดิม',
      oldPasswordPlaceholder: 'กรอกรหัสผ่านเดิมของคุณ',
      newPassword: 'รหัสผ่านใหม่',
      newPasswordPlaceholder: 'กรอกรหัสผ่านใหม่ของคุณ',
      confirmPasswordPlaceholder: 'กรอกรหัสผ่านใหม่ของคุณอีกครั้ง',
      incomplete: 'กรุณากรอกให้ครบ!',
      mismatch: 'รหัสผ่านสองครั้งไม่ตรงกัน',
    },
    setname: {
      nameLabel: 'ชื่อ',
      namePlaceholder: 'กรอกชื่อจริงของคุณ',
      notice: 'เพื่อความปลอดภัยของบัญชี ชื่อจริงต้องตรงกับชื่อในบัตรธนาคารที่ผูกไว้',
      alreadySet: 'กรุณาอย่าตั้งค่าซ้ำ!',
      nameRequired: 'กรุณากรอกชื่อของคุณ!',
    },
    setsex: {
      male: 'ชาย',
      female: 'หญิง',
    },
    infomation: {
      avatar: 'รูปโปรไฟล์',
      chooseAvatar: 'เลือกรูปโปรไฟล์',
      realName: 'ชื่อจริง',
      notSet: 'ยังไม่ได้ตั้ง',
      gender: 'เพศ',
      unknown: 'ไม่ระบุ',
      bindInfo: 'ข้อมูลการผูก',
      bound: 'ผูกแล้ว',
      none: 'ไม่มี',
    },
    index: {
      recharge: 'เติมเงิน',
      withdraw: 'ถอนเงิน',
      myWallet: 'กระเป๋าเงินของฉัน',
      details: 'รายละเอียด',
      balanceLabel: 'ยอดคงเหลือ: ',
      personalReport: 'รายงานส่วนบุคคล',
      accountDetail: 'รายละเอียดบัญชี',
      profileCenter: 'ศูนย์ข้อมูลส่วนตัว',
      notice: 'ประกาศ',
      customerService: 'บริการลูกค้าออนไลน์',
      completeTaskFirst: 'กรุณาสมัครสมาชิกก่อน',
      contactServiceToRecharge: 'กรุณาติดต่อบริการลูกค้าออนไลน์เพื่อเติมเงิน',
      setPayoutCardFirst: 'กรุณาตั้งค่าบัตรรับเงินก่อน',
      featureDisabled: 'ฟีเจอร์นี้ยังไม่เปิดให้ใช้งาน',
      accountOffline: 'บัญชีถูกออกจากระบบ',
      loginRegister: 'เข้าสู่ระบบ/สมัครสมาชิก',
      loginHint: 'เข้าสู่ระบบเพื่อดู',
    },
    setting: {
      basicInfo: 'ข้อมูลพื้นฐาน',
      loginPassword: 'รหัสผ่านเข้าสู่ระบบ',
      payPassword: 'รหัสผ่านการชำระเงิน',
      payPasswordAlreadySet: 'ตั้งรหัสผ่านการชำระเงินแล้ว!',
      signOut: 'ออกจากระบบ',
    },
    gameRecord: {
      betAmount: 'ยอมเดิมพัน: {money}',
      betTime: 'เวลาเดิมพัน: {time}',
      settleTime: 'เวลาสรุปผล: {time}',
    },
    withdrawRecord: {
      amount: 'ยอมถอนเงิน: {money}',
      desc: 'หมายเหตุการถอนเงิน: {desc}',
      submitTime: 'เวลาที่ยื่นคำขอ: {time}',
      reviewTime: 'เวลาตรวจสอบ: {time}',
    },
    report: {
      profitLabel: 'กำไร/ขาดทุน',
      formulaTip: 'กำไร/ขาดทุน = เงินรางวัล - เงินเดิมพัน + เงินเติม - เงินถอน',
      playAmount: 'ยอมเดิมพัน',
      rechargeAmount: 'ยอมเติมเงิน',
      withdrawAmount: 'ยอมถอนเงิน',
      winAmount: 'ยอมรางวัล',
    },
    service: {
      contact: 'ติดต่อทันที',
      slogan: 'หากมีคำถามใด ๆ สามารถติดต่อเราได้ตลอดเวลา',
    },
  },
  video: {
    hallTitle: 'โรงหนังวิดีโอ',
    hotRecommend: 'แนะนำยอดนิยม',
    playCount: 'ดู:{count}',
    playCountSuffix: 'ดู {count} ครั้ง',
    rechargeToWatch: 'กรุณาเติมเงินก่อนรับชมวิดีโอ!',
  },
  recharge: {
    title: 'เติมเงิน',
    chooseCoin: 'เลือกสกุลเงิน',
    address: 'ที่อยู่รับเงิน',
    copy: 'คัดลอกที่อยู่',
    copied: 'คัดลอกแล้ว',
    amount: 'จำนวนเงินเติม',
    uploadShot: 'อัปโหลดภาพหน้าจอโอนเงิน',
    submit: 'ส่งคำขอเติมเงิน',
    pending: 'รอตรวจสอบ',
    done: 'เข้าบัญชีแล้ว',
    rejected: 'ถูกปฏิเสธ',
  },
  payMethod: {
    title: 'เลือกวิธีรับเงิน',
    bankCard: 'บัตรธนาคาร',
    wallet: 'กระเป๋าเงินคริปโต',
    unbind: 'ยกเลิกผูก',
    bindNew: 'ผูกที่อยู่ใหม่',
    confirmUnbind: 'ยืนยันยกเลิกผูกวิธีรับเงินนี้หรือไม่?',
    payPassword: 'รหัสผ่านถอนเงิน',
    wrongPassword: 'รหัสผ่านถอนเงินไม่ถูกต้อง',
    chooseFirst: 'กรุณาเลือกวิธีรับเงินก่อน',
  },
  router: {
    Index: { title: 'หน้าแรก' },
    Home: { title: 'หน้าแรก' },
    Choose: { title: 'คอมพานิอน' },
    List: { title: 'รายการคอมพานิอน' },
    Profile: { title: 'รายละเอียดคอมพานิอน' },
    Mine: { title: 'ของฉัน' },
    Video: { title: 'วิดีโอ' },
    Game: { title: 'เกม' },
    Login: { title: 'เข้าสู่ระบบ' },
    Register: { title: 'สมัครสมาชิก' },
    ServiceOnline: { title: 'ฝ่ายบริการ' },
    ServicePage: { title: 'ฝ่ายบริการ' },
    Setting: { title: 'ตั้งค่า' },
    Infomation: { title: 'ข้อมูลพื้นฐาน' },
    Setname: { title: 'เปลี่ยนชื่อจริง' },
    Setsex: { title: 'เปลี่ยนเพศ' },
    SetPayPassword: { title: 'รหัสผ่านการชำระเงิน' },
    SetLoginPassword: { title: 'รหัสผ่านเข้าสู่ระบบ' },
    Lottery: { title: 'หวย' },
    Notice: { title: 'ประกาศ' },
    PlayVideo: { title: 'เล่นวิดีโอ' },
    Setbank: { title: 'เพิ่มบัญชีรับเงิน' },
    BindCard: { title: 'เพิ่มบัญชีรับเงิน' },
    Withdraw: { title: 'ถอนเงิน' },
    Recharge: { title: 'เติมเงิน' },
    Personalreport: { title: 'รายงานส่วนตัว' },
    WithdrawRecord: { title: 'ประวัติการถอนเงิน' },
    AccountDetail: { title: 'รายการบัญชี' },
    GameRecord: { title: 'ประวัติเกม' },
  },
  captcha: {
    placeholder: 'รหัสยืนยันรูปภาพ',
    refresh: 'แตะเพื่อรีเฟรช',
    error: 'รหัสยืนยันไม่ถูกต้อง',
    required: 'กรุณากรอกรหัสยืนยัน',
  },
  login: {
    title: 'เข้าสู่ระบบ',
    usernamePlaceholder: 'กรุณากรอกชื่อผู้ใช้',
    passwordPlaceholder: 'กรุณากรอกรหัสผ่าน',
    forgotPassword: 'ลืมรหัสผ่าน?',
    noAccountRegister: 'ยังไม่มีบัญชี? สมัครสมาชิกเลย',
    submit: 'เข้าสู่ระบบ',
  },
  register: {
    title: 'สมัครสมาชิก',
    usernamePlaceholder: 'กรุณากรอกชื่อผู้ใช้ (6-12 ตัวอักษรภาษาอังกฤษหรือตัวเลข)',
    passwordPlaceholder: 'กรุณากรอกรหัสผ่านเข้าสู่ระบบ (6-12 ตัวอักษรภาษาอังกฤษหรือตัวเลข)',
    codePlaceholder: 'กรุณากรอกรหัสเชิญ',
    protocol: 'ฉันได้รับทราบและยอมรับข้อกำหนดต่าง ๆ ของ "ข้อตกลงเปิดบัญชี"',
    submit: 'สมัครสมาชิก',
    codeRequired: 'กรุณากรอกรหัสเชิญ!',
    agreementRequired: 'กรุณาติ๊กยอมรับข้อตกลงเปิดบัญชีด้านล่าง!',
  },
}
